// Fogos de artifício do fundo dos modais no Réveillon (components/season/SeasonBackdrop.vue). Mesma cena do fundo
// dos modais do R2 Security (r2-oauth-2.0-front, Helpers/global/modalSeasonSky.js, newYearScene), para os sistemas
// da R2 terem os mesmos fogos: foguetes que sobem pelas laterais (o miolo fica atrás da caixa do modal) e estouram
// numa coroa de 64 a 84 faíscas em traço, com miolo de faíscas lentas, clarão no centro e cintilar no fim.
//
//   createModalFireworks(canvas) -> {resize, destroy}
//     o canvas ocupa o elemento pai; para com a aba em segundo plano

const rand = (min, max) => min + Math.random() * (max - min);
const pick = list => list[Math.floor(Math.random() * list.length)];

// Paletas de cada estouro: dourado e champanhe na maioria, com algumas cores para variar
const FIREWORK_PALETTES = [
    ['#ffe9a8', '#f3d68a', '#e2b85c'],
    ['#fff4cf', '#f6e3a8', '#ffffff'],
    ['#ffd27a', '#ff9f5a', '#ffe9a8'],
    ['#5eead4', '#2dd4bf', '#ccfbf1'],
    ['#fda4af', '#fb7185', '#ffe4e6'],
    ['#c4b5fd', '#a78bfa', '#ede9fe'],
];
const GRAVITY = 34;

function newYearScene() {
    let rockets = [];
    let sparks = [];
    let flashes = [];
    let width = 0;
    let height = 0;
    let nextLaunch = 0.25;

    // Sobe pelas laterais: o miolo da tela fica atrás da janela do modal
    function launch() {
        const left = Math.random() < 0.5;
        const tx = left ? rand(0.06, 0.32) * width : rand(0.68, 0.94) * width;
        rockets.push({
            x: tx + rand(-50, 50), y: height + 8,
            sx: 0, sy: 0,
            tx, ty: rand(0.12, 0.42) * height,
            age: 0, life: rand(0.9, 1.3),
            palette: pick(FIREWORK_PALETTES),
        });
    }

    // Mesmo tamanho dos fogos do login (ChristmasDecor.vue): coroa de 64 a 84 faíscas quase na mesma velocidade,
    // um miolo de faíscas lentas para não ficar oca e um clarão rápido no centro
    function explode(rocket) {
        const count = Math.round(rand(64, 84));
        const power = rand(120, 175);
        const spark = (speed, angle, life, inner) => sparks.push({
            x: rocket.tx, y: rocket.ty,
            px: rocket.tx, py: rocket.ty,
            vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed,
            age: 0, life,
            color: pick(rocket.palette),
            twinkle: !inner && Math.random() < 0.45,
        });
        for (let i = 0; i < count; i++) {
            spark(power * rand(0.86, 1), (i / count) * Math.PI * 2 + rand(-0.04, 0.04), rand(1.5, 2.2), false);
        }
        for (let i = 0; i < 18; i++) spark(rand(10, power * 0.5), rand(0, Math.PI * 2), rand(0.9, 1.5), true);
        flashes.push({x: rocket.tx, y: rocket.ty, age: 0, life: 0.45, radius: power * 0.9});
    }

    return {
        resize(w, h) {
            width = w;
            height = h;
        },
        draw(ctx, dt, clock) {
            if (clock >= nextLaunch) {
                launch();
                if (Math.random() < 0.35) launch();
                nextLaunch = clock + rand(0.9, 2.1);
            }

            ctx.globalCompositeOperation = 'lighter';
            ctx.lineCap = 'round';

            rockets = rockets.filter(rocket => {
                if (!rocket.age) {
                    rocket.sx = rocket.x;
                    rocket.sy = rocket.y;
                }
                rocket.age += dt;
                const t = Math.min(1, rocket.age / rocket.life);
                const eased = 1 - Math.pow(1 - t, 3);
                const x = rocket.sx + (rocket.tx - rocket.sx) * eased;
                const y = rocket.sy + (rocket.ty - rocket.sy) * eased;
                const tail = ctx.createLinearGradient(x, y, x, y + 40);
                tail.addColorStop(0, 'rgba(255, 240, 200, 0.95)');
                tail.addColorStop(1, 'rgba(255, 200, 120, 0)');
                ctx.globalAlpha = 1;
                ctx.strokeStyle = tail;
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x - (rocket.tx - rocket.sx) * 0.04, y + 40);
                ctx.stroke();
                if (t >= 1) {
                    explode(rocket);
                    return false;
                }
                return true;
            });

            flashes = flashes.filter(flash => (flash.age += dt) < flash.life);
            for (const flash of flashes) {
                const glow = ctx.createRadialGradient(flash.x, flash.y, 0, flash.x, flash.y, flash.radius);
                glow.addColorStop(0, `rgba(255, 236, 180, ${0.32 * (1 - flash.age / flash.life)})`);
                glow.addColorStop(1, 'rgba(255, 236, 180, 0)');
                ctx.globalAlpha = 1;
                ctx.fillStyle = glow;
                ctx.fillRect(flash.x - flash.radius, flash.y - flash.radius, flash.radius * 2, flash.radius * 2);
            }

            const drag = Math.pow(0.42, dt);
            sparks = sparks.filter(spark => {
                spark.age += dt;
                if (spark.age >= spark.life) return false;
                spark.px = spark.x;
                spark.py = spark.y;
                spark.vx *= drag;
                spark.vy = spark.vy * drag + GRAVITY * dt;
                spark.x += spark.vx * dt;
                spark.y += spark.vy * dt;
                const fade = 1 - spark.age / spark.life;
                // No fim da vida, parte das fagulhas cintila antes de apagar
                const flicker = spark.twinkle && fade < 0.45 ? (Math.sin(clock * 38 + spark.x) > 0 ? 1 : 0.2) : 1;
                ctx.globalAlpha = Math.min(1, fade * 1.4) * flicker;
                ctx.strokeStyle = spark.color;
                ctx.lineWidth = 1.2 + fade * 1.3;
                ctx.beginPath();
                ctx.moveTo(spark.px - spark.vx * 0.03, spark.py - spark.vy * 0.03);
                ctx.lineTo(spark.x, spark.y);
                ctx.stroke();
                return true;
            });

            ctx.globalCompositeOperation = 'source-over';
            ctx.globalAlpha = 1;
        },
    };
}

export function createModalFireworks(canvas) {
    const ctx = canvas.getContext('2d');
    const scene = newYearScene();
    let width = 0;
    let height = 0;
    let clock = 0;
    let last = performance.now();
    let frame = 0;

    function resize() {
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        width = canvas.clientWidth || window.innerWidth;
        height = canvas.clientHeight || window.innerHeight;
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        scene.resize(width, height);
    }

    function tick(now) {
        const dt = Math.min(0.05, (now - last) / 1000);
        last = now;
        // Aba em segundo plano: o navegador já segura o requestAnimationFrame; aqui só não avança o tempo
        if (!document.hidden) {
            clock += dt;
            ctx.clearRect(0, 0, width, height);
            scene.draw(ctx, dt, clock);
        }
        frame = requestAnimationFrame(tick);
    }

    resize();
    frame = requestAnimationFrame(tick);

    return {
        resize,
        destroy() {
            cancelAnimationFrame(frame);
        },
    };
}
